import Colors from '@constants/colors';

export default {
    primary: Colors.COLOR_RED,
    secondary: Colors.COLOR_WHITE,
    error: Colors.COLOR_RED,
    inactive: Colors.COLOR_LIGHT_GREY,
};
